import type { CustomHeaderProps } from 'ag-grid-react'
import { DagColumnHeaderLabel } from './DagColumnHeaderLabel'

interface DagConditionalHeaderProps extends CustomHeaderProps {
  tooltipText: string
  isRequiredInput?: boolean
  isReorderable?: boolean
}

export function DagConditionalHeader(props: DagConditionalHeaderProps) {
  const { displayName, tooltipText, isRequiredInput, isReorderable } = props

  return (
    <DagColumnHeaderLabel
      displayName={displayName}
      isRequiredInput={isRequiredInput}
      isReorderable={isReorderable}
      tooltipText={tooltipText}
    />
  )
}
